<div class="cointainer-fluid">
  <div class="row">
    <div class="col">
      <h2 i18n="@@DialogSalesRequestOkText">
        La richiesta è stata inoltrata al customer service
      </h2>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div style="text-align: center">
        <button mat-raised-button (click)="closeDialog()" i18n="@@DialogClose" color="primary">Chiudi</button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/dialogs/sales-request-ok-dialog/sales-request-ok-dialog.html